import React, { useState, useCallback, useEffect } from "react";
import {
    usePlaidLink,
} from "react-plaid-link";
import { message } from "antd";
import axiosInstance from "../../helpers/axios";
import Button from '@mui/material/Button';

const LinkPlaid = (props) => {
    const [data, setData] = useState("");

    const onSuccess = useCallback(async (token, metadata) => {
        if (props.awaitingOnSuccess) {
            props.awaitingOnSuccess();
        }

        try {
            const url = props.type === "reconnect" ? "/api/plaid-arpari/reconnect/" : "/api/plaid-arpari/get-access-token/";
            metadata['storePlaidItems'] = props.storePlaidItems
            const res = await axiosInstance.post(
                url,
                metadata,
                {}
            );

            if (props.accessTokenOnSuccess) {
                props.accessTokenOnSuccess(res?.data);
            }

        } catch (err) {
            message.error("Error connecting account");
        }
    }, [props]);

    const fetchToken = useCallback(async () => {
        const url =
            props.type === "reconnect"
                ? "/api/plaid-arpari/create-update-link-token/"
                : "/api/plaid-arpari/create-link-token/";
        const params = props.type === "reconnect" ? { 
            accountId: props.plaidAccountId, 
            isAssigned: props.isAssigned,
            isSourceId: props.isSourceId,
        } : {}
        params.link_customization_name = props.linkCustomizationName || "default"
        if (props.plaidItemId) {
            params.plaid_item_id = props.plaidItemId;
        }
        const res = await axiosInstance.get(url, { params: params });
        const data = res.data.data.link_token;
        setData(data);
    }, [props.type, props.plaidAccountId, props.isAssigned, props.isSourceId, props.linkCustomizationName]);

    useEffect(() => {
        fetchToken();
    }, [fetchToken]);

    const config = {
        token: data,
        onSuccess: onSuccess,
    };

    const { open, ready } = usePlaidLink(config);

    return (
        <>
            {(props.buttonType) ? (
                <Button
                    type={props.buttonType}
                    onClick={() => open()}
                    disabled={!ready}
                    disableElevation fullWidth size="small" variant="contained" color="primary" sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                    style={props.buttonStyle ? props.buttonStyle : {}}
                >
                    {props.buttonText || "Connect Account"}
                </Button>
            ) : (
                <a
                    onClick={() => open()}
                    disabled={!ready}
                >
                    {props.buttonText || "Connect Account"}
                </a>
            )}


        </>
    );
};

export default LinkPlaid;
